import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import "@codetrix-studio/capacitor-google-auth";

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

import Model from './Model';

export default class User extends Model {

  id = null;
  name = null;
  email = null;
  token = null;
  created = null;
  updated = null;
  upgraded = null;

  constructor(data = {}) {
    super(data);
    Object.assign(this, data);
  }

  static async current() {
    try {
      let item = await Storage.get({ 
        key: "user" 
      });
      if (item) {
        let json = JSON.parse(item.value);
        return new User(json);
      }
      return null;
    }
    catch (error) {
      return null;
    }
  }

  static async login() {
    let auth = await Plugins.GoogleAuth.signIn();
    let idToken = auth.authentication.idToken;
    let accessToken = auth.authentication.accessToken;
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    let credential = firebase.auth.GoogleAuthProvider.credential(idToken, accessToken);
    let response = await firebase.auth().signInWithCredential(credential);
    let document = await firebase.firestore().collection("users").doc(response.user.uid).get();
    if (document && document.exists) {
      await document.ref.update({
        token: accessToken,
        updated: new Date().toISOString()
      });
    }
    else {
      await document.ref.set({
        id: response.user.uid,
        token: accessToken,
        email: response.user.email,
        name: response.user.name || response.user.displayName,
        created: new Date().toISOString(),
        updated: new Date().toISOString()
      }, { merge: true });
    }
    let user = new User(document.data());
    await Storage.set({ 
      key: "user", 
      value: JSON.stringify(user)
    });
    return user;
  }

  static async refresh() {
    let auth = await Plugins.GoogleAuth.signIn();
    let idToken = auth.authentication.idToken;
    let accessToken = auth.authentication.accessToken;
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    let credential = firebase.auth.GoogleAuthProvider.credential(idToken, accessToken);
    let response = await firebase.auth().signInWithCredential(credential);
    let users = firebase.firestore().collection("users");
    let document = await users.doc(response.user.uid).get();
    await document.ref.update({
      token: accessToken,
      updated: new Date().toISOString()
    });
    let user = new User(document.data());
    user.token = accessToken;
    await Storage.set({ 
      key: "user", 
      value: JSON.stringify(user)
    });
    return user;
  }

  async upgrade(token, amount=499, currency="cdn", test=true) {
    let url = process.env.VUE_APP_STRIPE_FUNCTION_URL;
    let params = {
      token: token,
      amount: amount,
      currency: currency,
      test: test
    };
    let stripe = await Vue.axios.post(url, params);
    let payments = firebase.firestore().collection("payments");
    await payments.doc(this.id).set(stripe.data, { merge: true });
    const users = firebase.firestore().collection("users");
    let document = await users.doc(this.id).get();
    let timestamp = new Date().toISOString();
    await document.ref.update({
      upgraded: timestamp,
      updated: timestamp
    });
    let user = new User(document.data());
    user.upgraded = timestamp;
    user.updated = timestamp;
    await Storage.set({ 
      key: "user", 
      value: JSON.stringify(user)
    });
    return user;
  }

  static async logout() {
    try {
      await firebase.auth().signOut();
    }
    catch {
      //ignore exception
    }
    try {
      await Plugins.GoogleAuth.signOut();
    }
    catch {
      //ignore exception
    }
    try {
      await Storage.set({ key: "user", value: null });
    }
    catch {
      //ignore exception
    }
  }

}